import { CircularProgress } from '@frontierag/frontier-ui-library';

import { styles } from './styles';

function AppLoader() {
  return <CircularProgress sx={styles} />;
}

export default AppLoader;
